import { useCallback, useMemo } from 'react';

import {
  createSpec,
  specTypes,
  useFetch,
  useDataRefId,
  useRefetch,
} from '@bingads-webui-react/overreact';
import stringify from 'json-stable-stringify';

import {
  fetchRequestContract,
  fetchResponseContract,
} from '../spec/coll-fetch';

import { environmentLookupFn } from '../../../environment/environment-instance';

const fetchSpec = createSpec(
  fetchRequestContract, fetchResponseContract,
  specTypes.FETCH, null, environmentLookupFn
);
const refetchSpec = createSpec(
  fetchRequestContract, fetchResponseContract,
  specTypes.REFETCH, null, environmentLookupFn
);

export function useCountryCurrenciesMappings(dataLocator, config = {}) {
  const dataRefKey = `${stringify(dataLocator)}`;
  const dataRefId = useDataRefId(dataRefKey, environmentLookupFn);

  const defaultConfig = useMemo(() => ({
    fetch: config.fetch || {},
    refetch: config.refetch || {},
  }), [config]);

  const { fetch: fetchConfig, refetch } = defaultConfig;

  const [data, error] = useFetch(dataRefId, fetchSpec, dataLocator, fetchConfig);
  const refetchFn = useRefetch(dataRefId, refetchSpec, refetch);

  const read = useCallback((param = {}, requestConfig) => {
    refetchFn({
      variables: { ...dataLocator, ...param.variables },
    }, requestConfig);
  }, [dataLocator, refetchFn]);

  return [{ data, error }, { read }];
}
